import React from 'react';
import { connect } from 'react-redux';
import NavBar from '../../components/NavBar/NavBar';

function NewGoalPage(props) {
  const { authedUser } = props;
  const typeFormEmbedCode = `<html> <head> <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"> <title>Plato Goal Setter</title> <style type="text/css"> html{ margin: 0; height: 100%; overflow: hidden; } iframe{ position: absolute; left:0; right:0; bottom:0; top:1; border:0; } </style> </head> <body> <iframe id="typeform-full" width="100%" height="90%" frameborder="0" allow="camera; microphone; autoplay; encrypted-media;" src="https://form.typeform.com/to/iKH2a6LY#username=${authedUser}"></iframe> <script type="text/javascript" src="https://embed.typeform.com/embed.js"></script> </body> </html>`;
  return (
    <div>
      <NavBar />
      <div
        className='content'
        dangerouslySetInnerHTML={{
          __html: typeFormEmbedCode,
        }}
      ></div>
    </div>
  );
}

function mapStateToProps({ authedUser }) {
  return {
    authedUser,
  };
}

export default connect(mapStateToProps)(NewGoalPage);
